(() => {
  const main = document.querySelector(
    "main[data-template='product.film-developing'], main[data-template='product.film-developing-pro']"
  );

  if (!main) return;

  const applyDevelopingOptionRules = () => {
    const selects = Array.from(main.querySelectorAll('select'));

    const turnaround = selects.find((select) => select.name === 'options[Turnaround]');
    if (turnaround) {
      Array.from(turnaround.options).forEach((option) => {
        if (option.value === '1 Hour' && option.textContent !== 'Fast service — 1 or 2 hours') {
          option.textContent = 'Fast service — 1 or 2 hours';
        }
      });
    }

    const physicalItems = selects.find(
      (select) => select.name === 'options[Negatives and printed photographs]'
    );

    if (!physicalItems) return;

    let selectionChanged = false;
    const invalidOptions = Array.from(physicalItems.options).filter((option) =>
      /,\s*no negatives$/i.test(option.value)
    );

    invalidOptions.forEach((option) => {
      if (option.selected) selectionChanged = true;
      option.disabled = true;
      option.hidden = true;
    });

    if (selectionChanged) {
      const fallback = Array.from(physicalItems.options).find(
        (option) => !option.disabled && !option.hidden
      );

      if (fallback) {
        physicalItems.value = fallback.value;
        physicalItems.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };

  applyDevelopingOptionRules();

  const observer = new MutationObserver(applyDevelopingOptionRules);
  observer.observe(main, { childList: true, subtree: true });
})();
